import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "../../src/images/logoDocLift.png";
import userIcon from "../../src/images/user.svg";
import { getDataFromLocalStorage } from "../util/localStorage";
import AI_PDF_CONST from "../util/PdfAiConst";

const Header = () => {
  const [userInfo, setUserInfo] = useState(null); // Default to null for better type handling
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const user = getDataFromLocalStorage("userInfo");
    setUserInfo(user); // Update state with user info
  }, [location]); // Run on mount and location change

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="headerRow top-0 z-50 fixed bg-white w-full flex justify-between items-center px-4 shadow-md">
      {/* Logo */}
      <div>
        <Link to={AI_PDF_CONST.ROUTE.HOME}>
          <img className="sm:h-[30px] h-[24px]" src={logo} alt="Logo" />
        </Link>
      </div>
      <div className="flex flex-row items-center">
        {/* Navigation Links */}
        <nav>
          <ul className="flex space-x-4">
            {location.pathname === "/ai-comm" && (
              <>
                <li>
                  <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-blue-500 transition font-medium">features</button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('benefits')} className="text-gray-700 hover:text-blue-500 transition font-medium">benefits</button>
                </li>
              </>
            )}
            {/* <li>
              <Link to="/" className="hover:text-blue-500 transition">
                Home
              </Link>
            </li>
            <li>
              <Link to="/documents" className="hover:text-blue-500 transition">
                Documents
              </Link>
            </li> */}
            {userInfo ? (
              <>
                <li>
                  <NavLink
                    to="/my-docs"
                    className={({ isActive }) =>
                      `transition text-lg ${isActive ? "font-bold text-blue-600" : "font-medium text-gray-700 hover:text-blue-500"}`
                    }
                  >
                    My Docs
                  </NavLink>
                </li>
              </>
            ) : null}
          </ul>
        </nav>

        {/* User Info */}
        <div className="flex userCol items-center border-l border-gray-300 pl-2 ml-4">
          {userInfo ? (
            <div>
              <span className="headerUserIcon relative pr-[15px] inline-block">
                <img
                  src={
                    userInfo.userProfileImg ? userInfo.userProfileImg : userIcon
                  }
                  alt="User Icon"
                  className="mr-2 rounded-full cursor-pointer"
                  height={35}
                  width={35}
                />
              </span>
              <div className="absolute userInfoCol right-[10px] bg-white top-[50px] shadow-md">
                <ul className=" w-[200px]">
                  <li className="w-full px-4 py-2 border-b border-[#efefef]">
                    <span className="text-gray-700 font-medium block">
                      {userInfo?.name}
                    </span>
                  </li>
                  <li
                    onClick={logout}
                    className="w-full px-4 py-2 border-b hover:bg-[#f1f1f1] cursor-pointer"
                  >
                    <span>Logout</span>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <Link to="/login" className="hover:text-blue-500 transition">
              <span className="text-gray-700 font-medium ml-2">Login</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
